import React from 'react';
import MonthSection from './MonthSection.jsx';

/**
 * The endless vertical list of month sections.
 *
 * @param {string[]} months ordered month keys
 * @param {(monthKey: string, node: HTMLElement|null) => void} registerSection
 */
export default function CalendarScroller({ months, registerSection, ...sectionProps }) {
  return (
    <div className="flex flex-col gap-8 py-4">
      {months.map((monthKey) => (
        <div key={monthKey} ref={(node) => registerSection(monthKey, node)}>
          <MonthSection monthKey={monthKey} {...sectionProps} />
        </div>
      ))}
    </div>
  );
}
